// (C) Copyright 2020 MediaWink, LLC

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  IconButton,
  TextField,
} from '@material-ui/core';

import Image from './Image';
import {
  triggerAddChildSaga,
  triggerPushBreadcrumbSaga,
  triggerSyncItemsFromGoogleDocSaga,
} from '../actions/items';
import {
  BuildIcon,
  CheckmarkIcon,
  DeleteIcon,
  EditIcon,
  PublicIcon,
  PrivateIcon,
  SharedIcon,
  SyncIcon,
} from '../constants/icons';
import {
  selectPrivateBreadcrumbs,
  selectPage,
  selectSelectedId,
} from '../selectors';

function Item({
  debug,
  toggleCompleteItem,
  removeItem,
  name,
  id,
  childrenCount,
  setSelection,
  hideDelete,
  hideEdit,
  hideCheckmark,
  updateItem,
  item,
  publicVisibility,
  privateVisibility,
  sharedVisibility,
}) {
  // console.log({ item });
  const dispatch = useDispatch();
  const privateBreadcrumbs = useSelector(selectPrivateBreadcrumbs);
  const navigate = useNavigate();
  const pushBreadcrumbSaga = (idValue, nameValue, pv, recursive, nav) => dispatch(
    triggerPushBreadcrumbSaga({
      id: idValue,
      name: nameValue,
      privateVisibility: pv,
      recursive,
      nav,
      navigate,
    }),
  );
  const syncItemsFromGoogleDocSaga = (breadcrumbs, idValue, nameValue, syncFile, nav) => dispatch(
    triggerSyncItemsFromGoogleDocSaga(breadcrumbs, idValue, nameValue, syncFile, nav),
  );
  const addChildSaga = (breadcrumbs, idValue, nameValue) => dispatch(
    triggerAddChildSaga(breadcrumbs, idValue, nameValue),
  );
  const selectedId = useSelector(selectSelectedId);
  const page = useSelector(selectPage);

  const enableEdit = () => {
    if (selectedId !== id) {
      setSelection(privateBreadcrumbs, id);
    }
  };

  const endEdit = () => {
    if (selectedId === id) {
      setSelection(null, null);
    }
  };

  const updateItemValue = (i, value, keys) => {
    // console.log('*** updateItemValue', i, value, keys);
    endEdit();
    if (typeof value !== 'string') {
      return;
    }
    if (!value.trim()) {
      return;
    }
    const payload = {
      'item_id': i.id,
      'Name': value,
      'item': {
        ...i,
        'Name': {
          'type': 'Text',
          'value': value.trim(),
          ...keys,
        },
      },
    };
    updateItem(payload);
  };

  const [value, setValue] = useState(name);
  useEffect(() => {
    // setValue(item.Name.value);
  }, [item?.Name?.value]);
  // console.log('item', item);
  let itemText = '';
  let count;
  try {
    count = item?.items?.length > 0 ? ` (${item?.items?.length})` : '';
  } catch (err) {
    count = '';
  }
  if (debug) {
    itemText = `[${item?.order}] ${item?.Name?.value} {${item?.id}}`;
  } else {
    itemText = `${item?.Name?.value}`;
  }
  return (
    <Box>
      <Box
        display='flex'
        flexDirection='row'
        basis='full'
      >
        {!hideDelete
          && (
            <Box>
              <IconButton
                aria-label='delete'
                onClick={() => removeItem({ data: { id } })}
                size='small'
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          )}
        {!hideCheckmark
          && (
            <Box>
              <IconButton
                aria-label='checkmark'
                onClick={() => toggleCompleteItem()}
                size='small'
              >
                <CheckmarkIcon />
              </IconButton>
            </Box>
          )}
        {!hideEdit
          && (
            <Box>
              <IconButton
                aria-label='edit'
                onClick={() => {
                  enableEdit();
                }}
                size='small'
              >
                <EditIcon />
              </IconButton>
            </Box>
          )}
        {publicVisibility && <PublicIcon />}
        {sharedVisibility && <SharedIcon />}
        {privateVisibility && <PrivateIcon />}
        <Box
          style={{
            display: 'flex',
            flex: 1,
            textDecoration: item.completed ? 'line-through' : 'none',
          }}
        >
          {selectedId === id
            ? (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  updateItemValue(item, value.trim());
                }}
              >
                <TextField
                  style={{
                    padding: '0px',
                    color: 'dark-3',
                    textDecoration: item.completed ? 'line-through' : 'none',
                  }}
                  type='text'
                  className='input'
                  /*
                  onSelect={() => {
                    console.log('* onSelect(name)', name);
                    setValue(name);
                  }}
                  */
                  onBlur={() => {
                    updateItemValue(item, value);
                  }}
                  value={value}
                  onChange={(e) => {
                    // console.log('* onChangeText(e.target.value)', e.target.value);
                    // e.preventDefault();
                    setValue(e.target.value);
                  }}
                />
              </form>
            )
            : (
              <>
                <Box display='flex' alignItems='center'>
                  <Box
                    onClick={
                      () => {
                        // console.log('page', page);
                        // console.log('name', name);
                        // console.log('item', item);
                        // console.log('EmptyCharacter', page?.EmptyCharacter?.value);
                        if (page.DispenseCharacters) {
                          if (name === page?.EmptyCharacter?.value) {
                            const list = page?.DispenseCharacters?.value;
                            // console.log('list', list);
                            const length = list.length / 2;
                            const num = Math.floor(Math.random() * length);
                            // console.log('num', num, 'len', list.length / 2);
                            // console.log('arr', [...list]);
                            // let codePoint of list;
                            const random = [...list][num];
                            // console.log('random', random);
                            updateItemValue(item, random);
                            return;
                          }
                          // TODO: animate
                          // Update even if it isn't in the list,
                          // because the list might have changed (eg for Christmas)
                          updateItemValue(item, '❓');
                          return;
                        }
                        if (childrenCount >= 0) {
                          const recursive = page?.Name?.value === 'App List';
                          const nav = page?.Name?.value === 'App List' ? 'app' : null;
                          pushBreadcrumbSaga(id, name, privateVisibility, recursive, nav);
                        } else {
                          // console.log(`addChildSaga(${privateBreadcrumbs}, ${id}, ${name})`);
                          addChildSaga(privateBreadcrumbs, id, name);
                        }
                        if (page?.Name?.value === 'App List') {
                          // console.log('LAUNCH APP');
                          // console.log('navigating to app...');
                          navigate('app');
                          // console.log('navigated to app.');
                        }
                        // console.log('end onClick');
                      }
                    }
                  >
                    {itemText}
                    <b>
                      {count}
                    </b>
                  </Box>
                  {page.Name.value === 'App List'
                    && (
                      <Button>
                        <BuildIcon
                          onClick={() => pushBreadcrumbSaga(id, name, privateVisibility, true)}
                        />
                      </Button>
                    )}
                </Box>
                {item?.SyncFile
                  && (
                    <IconButton
                      aria-label='Sync'
                      onClick={() => {
                        // console.log('onClick');
                        try {
                          syncItemsFromGoogleDocSaga(
                            privateBreadcrumbs,
                            id,
                            name,
                            item.SyncFile,
                            navigate,
                          );
                        } catch (e) {
                          console.log('Caught (need to re-sign-in?):', e);
                        }
                      }}
                      size='small'
                    >
                      <SyncIcon />
                    </IconButton>
                  )}
              </>
            )}
        </Box>
      </Box>
      {itemText.startsWith('http') && (
        <Image
          width={200}
          height={200}
          src={itemText}
          alt='2'
          referrerPolicy='no-referrer'
        />
      )}
      {itemText.includes('=http') && (
        <Image
          width={200}
          height={200}
          src={itemText.split('=').slice(1).join('=')}
          alt='3'
          referrerPolicy='no-referrer'
        />
      )}
      {itemText.includes('=data:image') && (
        <Image
          width={200}
          height={200}
          src={itemText.split('=').slice(1).join('=')}
          alt='4'
          referrerPolicy='no-referrer'
        />
      )}
    </Box>
  );
}

Item.propTypes = {
  debug: PropTypes.bool.isRequired,
  toggleCompleteItem: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
  completed: PropTypes.bool,
  name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  childrenCount: PropTypes.number.isRequired,
  setSelection: PropTypes.func.isRequired,
  hideDelete: PropTypes.bool,
  hideEdit: PropTypes.bool,
  hideCheckmark: PropTypes.bool,
  publicVisibility: PropTypes.bool,
  privateVisibility: PropTypes.bool,
  sharedVisibility: PropTypes.bool,
  item: PropTypes.object.isRequired,
  updateItem: PropTypes.func.isRequired,
};

Item.defaultProps = {
  publicVisibility: false,
  privateVisibility: false,
  sharedVisibility: false,
  completed: false,
  hideDelete: false,
  hideEdit: false,
  hideCheckmark: false,
};

export default Item;
